import { ClientObject } from '@lyrahealth-inc/shared-app-logic/src/models/client/Client'

import { baseApi, RTKQueryTag } from '../../../../data/baseApi'

type GetClientArgs = {
  providerId: string
  clientId: string
}

type GetClientIdArgs = {
  relationshipId: string
}

type GetClientIdResponse = {
  patient_id: string
  provider_id: string
}

const ltClientApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getClient: builder.query<ClientObject, GetClientArgs>({
      query: ({ providerId, clientId }) => ({
        method: 'get',
        url: `/v1/clients/${clientId}`,
        params: { providerId, is_bcx: true },
      }),
      providesTags: (_result, _error, { clientId }) => [{ type: RTKQueryTag.INDIVIDUAL_CLIENT, id: clientId }],
    }),
    getClientId: builder.query<GetClientIdResponse, GetClientIdArgs>({
      query: ({ relationshipId }) => ({
        method: 'get',
        url: `/lt/v1/provider_patient/${relationshipId}`,
      }),
    }),
  }),
})

export const { useGetClientQuery, useLazyGetClientIdQuery, useLazyGetClientQuery } = ltClientApi
export default ltClientApi
